import { createIcon } from '@chakra-ui/react';

export const ArrowDownIcon = createIcon({
  displayName: 'ArrowDownIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="14"
        // height="14"
        viewBox="0 0 14 14"
        fill="none"
      >
        <path
          d="M10.5407 8.41797L6.99982 11.9588L3.45898 8.41797"
          stroke="#6E6789"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 2.04297V11.8605"
          stroke="#6E6789"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  ),
});
